import { render, staticRenderFns } from "./ServiceBk.vue?vue&type=template&id=ef7ed7e8&scoped=true"
import script from "./ServiceBk.vue?vue&type=script&lang=js"
export * from "./ServiceBk.vue?vue&type=script&lang=js"
import style0 from "./ServiceBk.vue?vue&type=style&index=0&id=ef7ed7e8&prod&lang=scss&scoped=true"
import style1 from "./ServiceBk.vue?vue&type=style&index=1&id=ef7ed7e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7ed7e8",
  null
  
)

export default component.exports